import React from 'react';

/*
 * ONE SHARED LIST, OR A PRIVATE LIST EACH.
 *
 * Gordon, 22 October: the to-dos picked out of a meeting (or a call) go
 * either into ONE list shared with everybody who was there, so each person
 * sees what the others took on, or into A PRIVATE LIST PER PERSON, so each
 * sees only their own. The organiser decides when the meeting is made, and
 * whoever extracts the to-dos afterwards can still change it here; a call
 * has no organiser, so it starts on shared and asks the same question.
 *
 * Two radio buttons that look like a switch, and one sentence under them
 * saying what the choice means - the words matter more than the control.
 */
export const MODE_WORDS = {
  shared: {
    label: 'One shared list',
    said: 'One list, shared with everybody who was there: each person sees what the others took on.'
  },
  personal: {
    label: 'A private list each',
    said: 'Each person gets their own list with only their items in it; nobody sees anybody else\'s.'
  }
};

export default function TodosModeChoice({ value, onChange, name = 'todos-mode', disabled = false, compact = false }) {
  const mode = value === 'personal' ? 'personal' : 'shared';
  return (
    <div className={`mt-mode${compact ? ' is-compact' : ''}`} data-todos-mode={mode}>
      <div className="mt-mode-switch" role="radiogroup" aria-label="To-dos from this meeting">
        {Object.entries(MODE_WORDS).map(([key, w]) => (
          <label key={key} className={`mt-mode-opt${mode === key ? ' is-on' : ''}`}>
            <input type="radio" name={name} value={key} checked={mode === key} disabled={disabled}
              onChange={() => onChange(key)} />
            <span>{w.label}</span>
          </label>
        ))}
      </div>
      {!compact && <p className="mt-mode-said">{MODE_WORDS[mode].said}</p>}
    </div>
  );
}
